function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
import { imageView } from '../../image-view';
import { CloseSmall, Cutting as Cutting1, Edit as Edit1, PreviewOpen, Upload as Upload1, ViewList as View, Delete as Remove } from '../../../common/icons';
import { useUpload } from '../rc-upload/';
import { Loading } from '../../loading/';
import { ProgressMask } from './ProgressMask';
export function Picture(props) {
  var size = props.size,
      file = props.file,
      _props$progress = props.progress,
      progress = _props$progress === void 0 ? 0 : _props$progress,
      _props$hasProgress = props.hasProgress,
      hasProgress = _props$hasProgress === void 0 ? false : _props$hasProgress,
      _props$hasClose = props.hasClose,
      hasClose = _props$hasClose === void 0 ? false : _props$hasClose,
      _props$border = props.border,
      border = _props$border === void 0 ? false : _props$border,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      iconRender = props.iconRender;

  var _useState = useState('width'),
      _useState2 = _slicedToArray(_useState, 2),
      widthOrHeight = _useState2[0],
      setWH = _useState2[1];

  var dom = useRef(null);

  var _useState3 = useState([0, 0]),
      _useState4 = _slicedToArray(_useState3, 2),
      s = _useState4[0],
      setS = _useState4[1];

  var pictureCls = usePrefixCls('upload-list-picture', {
    loading: file.fileStatus === "LOADING",
    border: border
  });
  var pictureContainerCls = usePrefixCls('upload-list-picture-container');
  var pictureLinkCls = usePrefixCls('upload-list-picture-link');
  var picturePreviewCls = usePrefixCls('upload-list-picture-preview');
  var actionListCls = usePrefixCls('upload-list-picture-action-list');
  var actionListItemCls = usePrefixCls('upload-list-picture-action-list-item');
  var closeCls = usePrefixCls('upload-list-picture-close');
  var fileUpload = useUpload();
  var removePicture = useCallback(function () {
    fileUpload.removeFileById(file.id);
  }, [file.id]);
  var handleActions = {
    view: {
      icon: React.createElement(PreviewOpen, {
        size: 24
      }),
      fn: useCallback(function () {
        imageView({
          images: fileUpload.files.map(function (file) {
            return {
              url: file.url
            };
          }),
          defaultActiveIndex: fileUpload.getIndexById(file.id)
        });
      }, [file.id])
    },
    edit: {
      icon: React.createElement(Cutting1, {
        size: 24
      }),
      fn: useCallback(function () {}, [file.id])
    },
    replace: {
      icon: React.createElement(Edit1, {
        size: 24
      }),
      fn: useCallback(function () {
        fileUpload.replaceFile(file.id);
      }, [file.id])
    },
    upload: {
      icon: React.createElement(Upload1, {
        size: 24
      }),
      fn: useCallback(function () {}, [file.id])
    },
    remove: {
      icon: React.createElement(Remove, {
        size: 24
      }),
      fn: removePicture
    }
  };
  var onLoad = useCallback(function (event) {
    var target = event.target;
    var width = target.naturalWidth || target.width;
    var height = target.naturalHeight || target.height;
    setWH(s[0] / s[1] > width / height ? 'height' : 'width');
  }, [s]);
  useEffect(function () {
    var node = dom.current;

    if (node) {
      var client = node.getBoundingClientRect();
      setS([client.width, client.height]);
    }
  }, [size]);
  return React.createElement("div", {
    className: classnames(pictureCls, className),
    style: size,
    ref: dom
  }, iconRender ? iconRender(file) : !hasProgress && file.fileStatus === "LOADING" ? React.createElement(Loading.BlockLoading, {
    show: true,
    maskStyle: {
      background: '#fff'
    }
  }) : React.createElement("div", {
    className: pictureContainerCls
  }, "image" === file.fileType ? React.createElement("a", {
    className: pictureLinkCls,
    href: file.href ? file.href : '#',
    target: file.href ? '_blank' : '_self',
    rel: "noreferrer",
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, React.createElement("img", {
    className: picturePreviewCls,
    onLoad: onLoad,
    style: _defineProperty({}, widthOrHeight, '100%'),
    src: file.url ? file.url : file.previewUrl
  })) : React.createElement(View, {
    size: "24px",
    className: picturePreviewCls
  })), hasClose && !actions.includes('remove') && React.createElement("div", {
    className: closeCls,
    onClick: removePicture
  }, React.createElement(CloseSmall, null)), file.fileStatus !== "INIT" && hasProgress && React.createElement(ProgressMask, {
    progress: progress,
    done: file.fileStatus !== "LOADING"
  }), actions.length === 0 || file.fileStatus === "LOADING" ? null : React.createElement("ul", {
    className: actionListCls
  }, actions.map(function (action) {
    return React.createElement("li", {
      className: actionListItemCls,
      key: action,
      onClick: handleActions[action].fn
    }, handleActions[action].icon);
  })));
}